// extracted by mini-css-extract-plugin
export default {"visible":"Npt2AT","xs":"XxGvWr","lg":"XNSwX0","aspect":"U7WiKH","image":"OAPM7a"};